module.exports = __webpack_public_path__ + "img/servicebg.6bc5129a.jpeg";